export default {"src":"/_next/static/image/public/images/ic_bell_notify.6f3ad8fda9f7adf2b8cb94cdf90a9e4b.svg","height":14,"width":14};